import React from 'react';
import isEqual from 'lodash/isEqual';

import {Select} from 'Components/Form';

import {User} from 'Services';
import ServicesApi from 'Services/Api/Services/Services';

/**
 * Asks which service a new record belongs to, only when more than one service fits.
 * With one possible service the server fills it in, so nothing is shown but a note.
 */
export default class ServicePicker extends React.Component {
    /**
     * @var state
     */
    state = {
        options: [],
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadOptions();
    };

    /**
     * @method componentDidUpdate
     * @param {object} prevProps
     */
    componentDidUpdate = (prevProps) => {
        const keys = ['serviceUserId', 'cmsElementId', 'employeeId'];

        if (!isEqual(keys.map(k => prevProps[k]), keys.map(k => this.props[k]))) {
            this.loadOptions();
        }
    };

    /**
     * @method loadOptions
     */
    loadOptions = async () => {
        const {serviceUserId, cmsElementId, employeeId, value, onChange} = this.props;

        if (!User.data?.service_access?.enabled) {
            return;
        }

        const response = await ServicesApi.get('/services/options', {
            service_user_id: serviceUserId ?? null,
            cms_element_id: cmsElementId ?? null,
            employee_id: employeeId ?? null,
        });

        if (!response.success) {
            return;
        }

        const options = response.data.data;

        this.setState({options});

        // Clear a choice that no longer fits, e.g. after the service user changes.
        if (value && !options.some(option => option.id === value)) {
            onChange(null);
        }
    };

    /**
     * @method render
     * @return {JSX.Element|null}
     */
    render() {
        const {options} = this.state;
        const {value, onChange, error, containerClassName = 'mb-4'} = this.props;

        if (!User.data?.service_access?.enabled || options.length === 0) {
            return null;
        }

        if (options.length === 1) {
            return (
                <p className={`${containerClassName} text-sm`}>
                    Service: <span className="font-bold">{options[0].name}</span>
                </p>
            );
        }

        return (
            <Select
                containerClassName={containerClassName}
                label="Service"
                id="service_id"
                value={value ?? null}
                error={error}
                onChange={onChange}
                options={options.map(option => ({label: option.name, value: option.id}))}
                isClearable
            />
        );
    }
}
